export const PL_TRANSLATION = {
		"COMPANIES_UPDATE_SUCCESS": "Zaktualizowano",
		"LIMIT": "Limit",
		"ACCOUNT_ID": "Konto rozliczeniowe",
		"SIGNIN": "Zaloguj",
		"SIGNIN_WELCOME_MESSAGE": "Zaloguj",
		"SIGNIN_EMAIL": "Email",
		"SIGNIN_PASSWORD": "Hasło",
		"SIGNIN_REMEMBER_ME": "Pamiętaj mnie",
		"SIGNIN_SUBMIT": "Zaloguj",
		"SIGNIN_FORGOT_PASSWORD": "Zapomniałeś hasła?",
		"SIGNIN_ERROR": "Złe dane",
		"PASSWORD_HEADING": "Resetuj hasło",
		"PASSWORD_EMAIL": "Email",
		"PASSWORD_SUBMIT": "Resetuj hasło",
		"PASSWORD_REQUEST_SUCCESS": "Sprawdź email aby zresetować hasło",
		"PASSWORD_REQUEST_ERROR": "Coś poszło nie tak..",
		"PASSWORD_RESET_SUCCESS": "Twoje hasło zostało zmienione, zostaniesz teraz zalogowany",
		"PASSWORD_RESET_ERROR": "Coś poszło nie tak",
		"PASSWORD_NEW_PASSWORD": "Nowe hasło",
		"PASSWORD": "Hasło",
		"DASHBOARD": "Podgląð",
		"DASHBOARD_HEADING": "Witaj w aplikacji",
		"GO_TO_DETAIL": "Zobacz szczegóły",
		"BOOKING_CROSSING": "Rezerwacja przeprawy",
		"BOOKING_OPERATOR": "Armator",
		"BOOKING_RELATION": "Relacja",
		"BOOKING_DEPARTURE_DATE": "Data",
		"BOOKING_DEPARTURE_HOURS": "Godzina",
		"BOOKING_DATA": "Dane przeprawy",
		"BOOKING_VEHICLE": "Dane pojazdu",
		"BOOKING_LENGTH": "Długość [m]",
		"BOOKING_WEIGHT": "Waga ładunku [t]",
		"BOOKING_LIST_RESERVATION_NUMBER": "Nr rezerwacji",
		"BOOKING_LIST_DATE": "Data",
		"BOOKING_LIST_OPERATOR": "Armator",
		"BOOKING_LIST_STATE": "Status",
		"BOOKING_LIST_RELATION": "Relacja",
		"BOOKING_LIST_VEHICLE": "Pojazd",
		"BOOKING_LIST_CONTRACTOR": "Kontrahent",
		"BOOKING_NUMBER": "Nr rezerwacji",
		"DEPARTURE_DATE": "Data",
		"BOOKING_STATUS": "Status",
		"ROUTE": "Relacja",
		"VEHICLE_NUMBER": "Pojazd",
		"CONTRACTOR": "Kontrahent",
		"CREATOR": "Zamawiający",
		"BOOKING_LIST_WORKING": "Bieżące",
		"BOOKING_LIST_HISTORY": "Historia",
		"BOOKING_LIST_NEW": "Nowe",
		"BOOKING_UPDATE_SUCCESS": "Przeprawa została zaktualizowana",
		"BOOKING_VEHICLE_TYPE": "Typ pojazdu",
		"BOOKING_VEHICLE_NUMBER": "Nr pojazdu",
		"BOOKING_REF": "Twój REF.",
		"BOOKING_CARGO_NUMBER": "Nr naczepy",
		"BOOKING_NUMBER_OF_DRIVERS": "Ilość kierowców",
		"BOOKING_DESCRIPTION": "Rodzaj ładunku",
		"BOOKING_CONTRACTOR": "Kontrahent",
		"BOOKING_LIST_CREATOR": "Zamawiający",
		"BOOKING_STATUS_MODIFIED": "Zmodyfikowany",
		"BOOKING_STATUS_MODIFIED_WAITLIST": "Zmodyfikowany - WL",
		"BOOKING_STATUS_DESTROYED": "Usunięto",
	  "BOOKING_STATUS_DESTROYED_PENDING": "Oczekuje na usunięcie",
		"BOOKING_STATUS_WAITING": "Oczekuje",
	  "BOOKING_STATUS_CONFIRMED": "Potwierdzony",
	  "BOOKING_STATUS_WAITLIST": "Oczekuje - WL",
		"BOOKING_STATUS_EXPIRED": "Wygasła",
		"BOOKING_STATUS_SUCCESS": "Zrealizowany",
		"BOOKING_STATUS_ERROR": "Błąd",
		"BOOKING_CREATE": "Zarezerwuj przeprawę",
		"BOOKING_CREATE_CATCH_LIMIT": "Limit kwotowy na przeprawy został przekroczony",
		"BOOKING_CREATE_RETURN": "Powrotna",
		"EMPTY_VEHICLE": "Pusty pojazd",
		"DRIVER_PHONE_NUMBER": "Nr tel. kierowcy",
		"DRIVER_PHONE_NUMBER_TOOLTIP": "Numer telefonu do powiadomień SMS",
		"SMS_NOTIFICATION": "Powiadomienia SMS",
	  "EMAIL_NOTIFICATION": "Powiadomienia Email",
		"SCANDLINES_DISCLAIMER": "Uwaga! Jeśli masz ładunek niebezpieczny, ponadgabarytowy lub przewozisz zwierzęta dokonaj rezerwacji drogą standardową aby uniknąć dodatkowych kosztów.",
		"TUNNEL_DISCLAIMER": "Dla aut z wysokością powyżej 4,05m zgłoś się bezpośrednio do spedytora. Możliwość rezerwacji tylko dla klasy 5 i 6 oraz szerokości do 2,55m.",
		"BOOKING_UPDATE_SUBMIT": "Edytuj",
		"PLUG_IN": "Podłączenie",
		"BOOKING_UPDATE": "Edycja przeprawy",
		"BOOKING_SELECT_RELATION": "Wybierz relację",
		"BOOKING_BOOKING_VALUE": "Kwota",
		"BOOKING_BOOKING_VALUE_OVERRIDE": "Inna kwota",
		"BOOKING_IS_BOOKING_VALUE_OVERRIDE": "Nadpisać kwotę?",
		"BOOKING_PAYMENT_STATUS": "Status płatności",
		"BOOKING_LIMIT": "Pozostały limit dla Twojej firmy: ",
		"BOOKING_LIMIT_WRONG": "Coś poszło nie tak",
		"BOOKING_INVOICE_ACCOUNT_ID": "Konto rozliczeniowe",
		"USERS_CREATE": "Dodaj użytkownika",
		"USERS_DATA": "Dane użytkownika",
		"USERS_UPDATE_EMAIL": "Email",
		"USERS_UPDATE_FIRSTNAME": "Imię",
		"USERS_UPDATE_LASTNAME": "Nazwisko",
		"USERS_UPDATE_PHONE": "Numer telefonu",
		"USERS_UPDATE_PASSWORD": "Hasło",
		"USERS_UPDATE_PASSWORD_CONFIRM": "Potwierdź hasło",
		"USERS_UPDATE": "Zaktualizuj użytkownika",
		"USER_SUSPENDED": "Zablokowany",
		"USER_CREATE_SUCCESS": "Użytkownik stworzony",
		"USERS_UPDATE_SUCCESS": "Użytkownik zaktualizowany",
		"FORM_SEARCH_PLACEHOLDER": "Szukaj",
		"COMPANIES_CREATE": "Stwórz firmę",
		"COMPANIES_DATA": "Dane firmy",
		"COMPANIES_USERS": "Użytkownicy",
		"APP_SETTINGS": "Ustawienia aplikacji",
		"FIRSTNAME": "Imię",
		"LASTNAME": "Nazwisko",
		"EMAIL": "Email",
		"POST_CODE": "Kod pocztowy",
		"NAME": "Nazwa",
		"VAT_ID": "NIP",
		"CUSTOMER_ID": "ID Klienta",
		"STREET": "Ulica",
		"CITY": "Miasto",
		"COUNTRY": "Kraj",
		"APP_SETTINGS_UPDATE": "Zaktualizuj aplikację",
		"SETTINGS_UPDATE_SUCCESS": "Dane zaktualizowane",
		"SETTINGS_CREATED_SUCCESS": "Dane zapisane",
		"SETTINGS_DELETED_SUCCESS": "Dane usunięte",
		"ADMIN": "Panel administracyjny",
		"LOGOUT": "Wyloguj",
		"LINE_ONE": "Nazwa",
		"LINE_TWO": "NIP / VAT ID",
		"LINE_THREE": "Linia 3",
		"LINE_FOUR": "Linia 4",
		"LINE_FIVE": "Linia 5",
		"UPLOAD_AVATAR_SENDED": "Avatar został zaktualizowany",
		"CANCEL": "Anuluj",
		"PACKAGE": "Zestaw",
		"OTHER": "Inne",
		"ROADTRAIN": "Road Train lub dłuższy",
		"CAR": "Samochód osobowy",
		"CCHNEW": "Autokar",
		"CON": "Kontener",
		"EXCVAN": "Karawana",
		"GLASS": "Auto ze stojakiem do przewozu okien",
		"HBOX": "Auto z przyczepą do przewozu koni",
		"LORRY": "Ciężarówka",
		"LT": "Ciężarówka z naczepą",
		"ST": "Ciągnik",
		"STKR": "Cysterna",
		"TT": "Zestaw",
		"TTKR": "Cysterna",
		"UNIT": "Tir",
		"VAN": "Van",
		'VANTLR': 'Van z naczepą',
		"CONFIRM_DESTROY_RECORD": "Czy na pewno chcesz usunąć rekord?",
		"DESTROY_RECORD": "Usuń",
		"UPDATE": "Zapisz",
		"ADD": "Dodaj",
		"NEW": "Nowy",
		"HISTORY_BACK_BUTTON": "Wróć",
		"EMPTY_PAGE": "Brak rekordów do wyświetlenia",
		"NOTFOUND": "Nic nie znaleźliśmy pod wskazanym adresem",
		"UNAUTHORIZED": "Twoja sesja wygasła",
		"FORBIDDEN": "Brak dostępu do wskazanego zasobu",
		"NONE": "Brak danych",
		"PARTIAL": "Częściowo",
		"FULL": "Opłacona",
		"ADMIN_BOOKING_LIST": "Lista przepraw ",
		"BOOKING_MULTI_TITLE": "Rezerwuj przeprawy",
		"BOOKING_MULTI_ROUTE": "Trasa",
		"BOOKING_MULTI_DATE": "Data",
		"BOOKING_MULTI_TIME": "Godz.",
		"BOOKING_MULTI_REF": "Twój REF",
		"BOOKING_MULTI_VEHICLE_TYPE": "Typ poj.",
		"BOOKING_MULTI_VEHICLE_WIDTH": "Długość",
		"BOOKING_MULTI_WEIGHT": "Waga",
		"BOOKING_MULTI_VEHICLE_PLATE": "Numer",
		"BOOKING_MULTI_TRAILER_PLATE": "Naczepa",
		"BOOKING_MULTI_CANCEL": "Anuluj",
		"BOOKING_MULTI_BOOK": "Rezerwuj",
		"BOOKING_MULTIPLY": "Przeprawa wielokrotna",
		"BOOKING_NO_OF_BOOKINGS": "Ilość przepraw",
		"AR": "Artic 16,5m",
		"CB": "Ciągnik",
		"CT": "Laweta",
		"DT": "Przyczepa",
		"HB": "Przyczepa dla koni",
		"RD": "Lorra/Van",
		"RT": "Road Train 18m",
		"PRINT_DOC": "Potwierdzenie",
		"AGREEMENT_TITLE": "Zgody",
		"AGREEMENT_DESC": "Proszę o zapoznanie się z poniższymi zgodami i zaznaczenie wszystkich.",
		"AGREEMENT_CHECK_ALL": "zaznacz wszystkie",
		"AGREEMENT_TANDC": "Oświadczam, że zapoznałem/am się z Warunkami korzystania - dostępnymi na stronie internetowej <a href=\"https://www.promyskat.pl/regulamin-serwisu\" target=\"_blank\">Regulamin</a> i akceptuję wszystkie zawarte w nim warunki.<br>Administratorem Twoich danych osobowych jest: SKAT Transport P.S.A. z siedzibą w Gdańsku.",
		"AGREEMENT_PRIVACY": "To w jaki sposób przetwarzamy Twoje dane osobowe możesz znaleźć w naszej <a href=\"https://www.promyskat.pl/polityka-prywatnosci\" target=\"_blank\">Polityce prywatności</a> dostępnej na stronie: Polityka prywatności",
		"AGREEMENT_PRIVACY2": "Oświadczam, że zapoznałem/am się z <a href=\"https://www.promyskat.pl/polityka-prywatnosci\" target=\"_blank\">Polityką prywatności</a>",
		"AGREEMENT_CONFIRM": "Wyślij",
		"BOOKING_QUEUE_RESET": "Kasuj listę",
		"WAITING_FOR_BOOKINGS": "Oczekiwanie na nowy booking",
		"SPEDITOR_MODE": "Spedytor",
		"STANDARD_MODE": "Standard",
    "MANAGER_MODE": "Menedżer",
		"CUSTOMER": "Klient",
		"LANG": "Język",
		"PHONE": "Nr telefonu",
		"ERROR_NO_SPEDITOR_ID": "Brak konfiguracji spedytora",
		"USERS_SPEDITOR_ID": "ID spedytora",
		"ATTACHMENT": "Załącznik",
	  "BPP": "Truck Trailer",
	  "BPO": "Lorry",
	  "TE": "Trailer",
	  "CH": "Chassis",
	  "UPLOAD_VEHICLES": "Konfiguracja pojazdów",
	  "UPLOAD": "Dodaj listę",
	  "DOWNLOAD": "Pobierz",
	  "NOTHING_TO_DOWNLOAD": "Brak danych do pobrania",
	  "DELETE": "Usuń",
	  "SAVE": "Zapisz",
	  "UPLOADED_VEHICLES_CREATED_SUCCESS": "Zapisano zmiany",
	  "UPLOADED_VEHICLES_BAD_FILE": "Nieprawidłowy plik",
		"ACTIVITY_HOURS": "Godziny dostępności",
		"ACTIVITY_HOURS_ACTIVE": "Ograniczenia czasowe",
		"ACTIVITY_HOURS_START": "Od",
		"ACTIVITY_HOURS_END": "Do",
		"BOOKINGS_NOT_PERMITTED_DUE_TO_AVAILABILITY_HOURS": "W chwili obecnej brak możliwości składania nowych bookingów",
		"ADR_INFO": "UN, grupa i klasa",
		"FGTVAN": "FGTVAN",
		"OVERSIZED": "Ponadgabaryt",
		"BOOKING_OVERSIZED_WIDTH": "Szer. [m]",
		"BOOKING_OVERSIZED_HEIGHT": "Wys. [m]",
		"BOOKING_OVERSIZED_WEIGHT": "Waga [t]",
	  "ACCOUNT_MANAGER": "Account manager",
	  "BOOKING_ADMIN": "Admin Bookingów",
	  "ADD_FILE": "Dodaj plik",
	  "CLEAR_FILE": "Usuń plik",
	  "ADR_DECLARATION": "Deklaracja ADR",
	  "ADR_DISCLAIMER": "Należy dostarczyć deklarację ładunku niebezpieczniego. Możesz załączyć ją w poniższym polu.",
		"SEMITRAILER": "Semi Trailer",
		"TRUCKTRAILER": "Truck Trailer",
    "ARTIC": "Artic",
		"TRAILER": "Naczepa",
		"VEHICLE": "Pojazd",
	  "TANKER": "Cysterna",
	  "TRACTOR": "Ciągnik",

		"AFTERHOURS_TITLE": "Ważna informacja",
		"AFTERHOURS_DESC": "Rezerwacja nie została zmieniona ani anulowana.\nUprzejmie prosimy o kontakt z numerem dyżurnym w celu uzyskania dalszych informacji.",
		"AFTERHOURS_PHONE": "+48 532 773 112",
		"AFTERHOURS_CONFIRM": "Rozumiem"
}


/** WEBPACK FOOTER **
 ** ./frontend/components/translates/pl.const.js
 **/